// export const BASE_URL = 'https://localhost:5001';
export const BASE_URL = 'https://system.elmo3eda.com';
